import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-aufbau-inhalt.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')